import {AlertIcon, ArchiveIcon, LockIcon} from '@primer/octicons-react'

import {Resources} from '../../../strings'
import styles from './select-menu-error.module.css'

export function SelectMenuError({error}: {error: Error}) {
  const apiErrorCode = error.name
  const {displayErrorMessage, icon} = (() => {
    switch (apiErrorCode) {
      case 'RepoArchived': {
        return {displayErrorMessage: Resources.repoArchivedErrorMessage, icon: <ArchiveIcon size={26} />}
      }
      case 'Forbidden': {
        return {displayErrorMessage: Resources.forbiddenErrorMessage, icon: <LockIcon size={26} />}
      }
      case 'IssueTypesDisabledForRepo':
      case 'IssueTypesDisabledForRepoOwner': {
        return {displayErrorMessage: error.message, icon: <AlertIcon size={26} />}
      }
      default: {
        return {displayErrorMessage: Resources.genericErrorMessage, icon: <AlertIcon size={26} />}
      }
    }
  })()

  return (
    <div className={styles.selectMenuErrorContainer}>
      <div className={styles.selectMenuErrorIcon}>{icon}</div>
      <p className={styles.selectMenuErrorText}>{displayErrorMessage}</p>
    </div>
  )
}
